export default __webpack_public_path__ + "static/media/burbuja_der_fondo.a3675b8f.png";